import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser, useUpdateUser } from '@/features/auth/state/auth'

import api from '@/lib/api'
import { UpdateUserLiAceitoData } from '@/types/user'

export function useUpdateUserLiAceito() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()
  const updateUser = useUpdateUser()

  return useMutation({
    mutationFn: async ({ data }: { data: UpdateUserLiAceitoData }) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      updateUser({ li_aceito: data.li_aceito })

      const response = await api.post(`/user/liAceito`, data, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data) return response.data
      throw new Error('Erro ao atualizar o tipo de usuário')
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['user'] })
    },
    onError: error => {
      console.error('Erro ao atualizar o tipo de usuário:', error)
    }
  })
}
